import { render, staticRenderFns } from "./addCompany.vue?vue&type=template&id=cdd7cefe&scoped=true&"
import script from "./addCompany.vue?vue&type=script&lang=ts&"
export * from "./addCompany.vue?vue&type=script&lang=ts&"
import style0 from "./addCompany.vue?vue&type=style&index=0&id=cdd7cefe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd7cefe",
  null
  
)

export default component.exports